import { TeamsService } from '@teams/infra';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AddTeamMemberBody, AddTeamMemberPathParams } from '@core-http';

export class AddTeamMemberCommandHandler {
  private readonly teamsService: TeamsService = inject(TeamsService);

  add(teamId: string, userIds: string[]): Observable<void> {
    const pathParams: AddTeamMemberPathParams = { teamId };
    const requestBody: AddTeamMemberBody = {
      userIds: userIds,
      isAutoApproved: false
    };

    return this.teamsService.addTeamMember(pathParams, requestBody);
  }
}
